import modelBase from "../model-base.model";
import modelBaseV2 from '../../models/model-base-v2.model';
import moment from "moment";

var jpoScheduleModel = {    
    
    manualProcessJPOSchedule: function (successCallback, failureCallback, filter) {
        modelBase.post(successCallback, failureCallback, '/api/jpo/routeschedule/manualRoute', { body: filter });
    },
    getSchedulePlanAndActualList: function (successCallback, failureCallback, filter) {
        modelBase.post(successCallback, failureCallback, '/api/schedule/planactualreport/summary', { body: filter });
    },

    getSchedulePlanAndActualUnplannedStore: function (successCallback, failureCallback, filter) {
        modelBase.post(successCallback, failureCallback, '/api/schedule/planactualreport/unplannedstore', { body: filter });
    },

    getJPOErrorMessage: function (successCallback, failureCallback, filter) {
        /*const qs = modelBase.toQueryString(filter);
        modelBase.get(successCallback, failureCallback, `/api/schedule/planactualreport/getjpoerrormsg?${qs}`);
        */
        modelBase.post(successCallback, failureCallback, '/api/schedule/planactualreport/getjpoerrormsg', { body: filter });
    },

    getSchedulePlanAndActualWeeklyMonthlyList: function (successCallback, failureCallback, filter) {
        modelBase.post(successCallback, failureCallback, '/api/schedule/planactualreport/weeklymonthly', { body: filter });
    },

    getSchedulePlanWorkloadOverviewList: function (successCallback, failureCallback, filter) {
        modelBase.post(successCallback, failureCallback, '/api/schedule/planactualreport/workloadoverview', { body: filter });
    },

    getSchedulePlanAndActualCodeMaster: function (successCallback, failureCallback, filter) {
        modelBase.post(successCallback, failureCallback, '/api/schedule/planactualreport/codemaster', { body: filter });
    },
    getScheduleRoute: function (successCallback, failureCallback, filter) {
        const qs = modelBase.toQueryString(filter);
        modelBase.get(successCallback, failureCallback, `/api/schedule/routingGet?${qs}`);
    },
    downloadExcel: (successCallBack, failureCallBack, request, fileName, storedProcedureCode, excelSheetNames, paramsMap) => {
        const path = '/api/retail/file/export/tr/file';
        const params = {
            sortBy: "",
            orderBy: "",
            pageIndex: 0,
            pageSize: 0,
            storedProcedureCode,
            params: paramsMap.map(param => ({
                code: param.code,
                value: param.value || request[param.property]
            })),
            excelSheetNames
        };

        modelBase.postDownload(successCallBack, failureCallBack, path, { body: params }, fileName + ".xlsx");
    },

    jpoSummaryDownloadExcel: (successCallBack, failureCallBack, request, fileName) => {

        jpoScheduleModel.downloadExcel(
            successCallBack,
            failureCallBack,
            request,
            fileName,
            "76",
            ["Actual vs Plan (Summary) Report", "Actual vs Plan (Summary)"],
            [
                { code: "156", property: "filterDate" },
                { code: "157", property: "BU" },
                { code: "158", property: "SupervisorRoles" },
                { code: "159", property: "SupervisorIds" },
                { code: "169", property: "ScheduleSource" },

                { code: "2", property: "orderBy" },
                { code: "24", property: "sortBy" },
                { code: "3", value: "0" },
                { code: "4", value: "0" },
                { code: "163", value: "1" } //IsExport
            ]
        );

    },

    jpoUnassignedStoresDownloadExcel: (params, fileName = `Unassigned Store Reason - ${moment().format('YYYYMMDDHHmm')}.xlsx`) => {
        return modelBaseV2.postDownload('/api/schedule/planactualreport/unplannedstore/reason/export', { body: params }, fileName);
    },

    jpoWeeklyMonthlyDownloadExcel: (successCallBack, failureCallBack, request, fileName) => {
        jpoScheduleModel.downloadExcel(
            successCallBack,
            failureCallBack,
            request,
            fileName,
            "77",
            ["Permanent Journey Plan Report", "Permanent Journey Plan"],
            [
                { code: "160", property: "StoreGrades" },
                { code: "161", property: "SiteGroups" },
                { code: "157", property: "BU" },
                { code: "158", property: "SupervisorRoles" },
                { code: "159", property: "SupervisorIds" },

                //{ code: "162", property: "LeadSupervisors" },                
                { code: "163", value: "1" } //IsExport
            ]
        );

    },

    jpoWorkloadOverviewDownloadExcel: (successCallBack, failureCallBack, request, fileName) => {

        jpoScheduleModel.downloadExcel(
            successCallBack,
            failureCallBack,
            request,
            fileName,
            "78",
            ["Workload Overview Report"],
            [
                { code: "156", property: "filterDate" },
                { code: "157", property: "BU" },
                { code: "158", property: "SupervisorRoles" },
                { code: "159", property: "SupervisorIds" },

                { code: "163", value: "1" } //IsExport
            ]
        );

    },

}

export default jpoScheduleModel;
